import $ from 'jquery'

// Like data-toggle-prefix, but keyed on whether an input has a value (vs. its value).
//   <input data-toggle-presence="foo"> shows `.foo-present` / hides `.foo-absent` when filled,
//   and vice versa. Works with free-text inputs.

const togglePresenceSelector =
  'input[data-toggle-presence],textarea[data-toggle-presence],select[data-toggle-presence]'

$(document).on(
  'input.toggle-presence change.toggle-presence toggle-presence',
  togglePresenceSelector,
  function () {
    const $this = $(this)
    const present = $this.val().trim().length > 0
    const isAjaxUpdating = window.Simplero?.state?.isAjaxUpdating
    const animate =
      ($this.data('toggle-presence-animate') ?? true) && !isAjaxUpdating

    $this
      .data('toggle-presence')
      .split(' ')
      .forEach((p) => {
        const prefix = p.trim()
        if (!prefix) return

        const [toShow, toHide] = present
          ? [`.${prefix}-present`, `.${prefix}-absent`]
          : [`.${prefix}-absent`, `.${prefix}-present`]

        $(toHide).hideInputs(animate)
        if (window.js_dom_ready || !isAjaxUpdating)
          $(toShow).showInputs(animate)
      })
  }
)

if (window.onDomChanged) {
  window.onDomChanged(togglePresenceSelector, 1000, function () {
    return this.trigger('toggle-presence')
  })
} else {
  $(function () {
    $(togglePresenceSelector).trigger('toggle-presence')
  })
}
